import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, Platform } from "react-native";
import ENV from "app/utils/ENV";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
} from "app/utils/styleSheet";
import storageActions from "app/utils/storageActions";
import {
  MaterialCommunityIcons,
  Entypo,
  FontAwesome,
  Ionicons,
} from "@expo/vector-icons";

import TextInput from "app/components/TextInput";
import Icon from "app/components/Icon";
import QuickActions from "app/components/QuickActions";
import ProgressRing from "app/components/ProgressRing";
import { default as MomentRing } from "app/components/chapter/MomentRing";
import ValueInspector from "app/components/ValueInspector";

import TimelineNodes from "app/components/TimelineNodes";
import RichText from "app/components/RichText";

import { StyleContext } from "app/contexts/Style";

export default class Value extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    value: PropTypes.object.isRequired,
    onPress: PropTypes.func,
    // onLongPress: PropTypes.func,
    showQuickActions: PropTypes.bool,
    selected: PropTypes.bool,
    distance: PropTypes.number,
    indicator: PropTypes.number,
    hiddenIds: PropTypes.array,
    todoIds: PropTypes.array,
    hideRing: PropTypes.bool,
    progressBar: PropTypes.bool,
  };

  static defaultProps = {
    size: 100,
  };

  constructor(props) {
    super(props);
    this.state = {
      showQuickActions: false,
      showQuickEdit: false,
      refreshKey: 0,
      isProject: valueHelpers.isProject(props.value),
      isInfinite: valueHelpers.isInfinite(props.value),
      noteValue: props.value?.is_note || props.noteValue,
    };
  }

  componentDidMount() {
    // console.log(this.props.date)
    // console.log(this.props.value)
  }

  // async componentDidUpdate(prevProps, prevState, snapshot){
  //   if(this.props.hideQuickAction != prevProps.hideQuickAction){
  //   }
  // }

  render() {
    let {
      value,
      onPress,
      onLongPress,
      onLongPressAdditionally,
      style,
      wrapperStyle,
      maxWidth,
      circle,
      onDeselect,
      showQuickActions,
      distance,
      selected,
      size,
      todoIds,
      hiddenIds,
      focusIds,
      showFocusRing,
      borderRadius,
      textIcon,
      scale,
      date,
    } = this.props;
    let { showQuickEdit, refreshKey, isProject, isInfinite, noteValue } =
      this.state;
    // let { date } = store.getState()

    // if(!value?.id) return null

    if (valueHelpers.isReference(value)) {
      value = valueHelpers.generateReference(value);
    }

    let doneToday = textHelpers.wasDoneToday(value, false, date);

    // let color = valueHelpers.getColor(value, this.context.colors);
    let color = valueHelpers.colorAsHex(value.color, this.context.colorScheme);
    if (!color) color = this.context.colors.trim;

    borderRadius = borderRadius || (size / 2) * screenRatio;

    // if (isInfinite) borderRadius = borderRadius / 4;

    if (showQuickEdit) return this.renderQuickEdit(value);

    return (
      <View
        style={[
          (valueHelpers.isSnoozed(value) || !!value.archived_at) && {
            opacity: 0.6,
          },
          { alignItems: "center" },
          // { borderWidth: 1 },
        ]}
        // onStartShouldSetResponder={(event) => true}
      >
        {/*...this.props*/}
        <TouchableOpacity
          style={[
            this.styles().wrapper,
            this.props.wrapperStyle,
            // StyleSheet.absoluteFillObject,
          ]}
          onPress={(e) => {
            if (this.innerTouch) return;
            // this.setState({
            //   showTimeline: this.state.showTimeline ? false : true,
            // });
          }}
          // onLongPress={() => {
          //   if (this.innerPress) return;
          //   return;
          // }}
        >
          <View
            ref={(ref) => {
              this.ref = ref;
            }}
            style={[
              this.styles().circleItem,
              {
                // width: size * screenRatio * (noteValue ? 1.5 : 1),
                width: noteValue ? "auto" : size * screenRatio,
                height: noteValue ? "auto" : size * screenRatio,
                minHeight: size * screenRatio,
                borderRadius,
                padding: (size / 10) * screenRatio,
                marginHorizontal: (size / 16) * screenRatio,
              },
              noteValue && {
                justifyContent: "flex-start",
                maxWidth: 200,
                minWidth: 100,
                maxHeight: 200,
              },
              style,
              !!scale && {
                transform: [
                  { scale },
                  // {translateY: '25%'}, // fromTop
                ],
              },
            ]}
            onLayout={({ nativeEvent }) => {
              if (this.ref) {
                this.ref.measure((x, y, width, height, pageX, pageY) => {
                  // console.log(`${value.text}: w:${width}, h:${height}, px:${pageX}, py:${pageY}`);
                  // console.log(`${value.text}: px:${pageX}, py:${pageY}`);
                  let absX = pageX + width / 2;
                  let absY = pageY + height / 2;
                  let measurements = {
                    x,
                    y,
                    width,
                    height,
                    pageX,
                    pageY,
                    absX,
                    absY,
                  };
                  this.setState({ absX, absY, measurements });
                  this.props.handleLayout &&
                    this.props.handleLayout(measurements);
                });
              } else console.log(`no ref for ${value.text}`);
            }}
          >
            {this.renderRing(value, color)}

            {this.renderColorBg(value, color, borderRadius)}

            {this.renderIcon(value, color, borderRadius)}

            {this.renderText(value, color, textIcon)}

            {this.renderQuickActions(value)}
          </View>
        </TouchableOpacity>

        {this.renderTimeline(value)}
      </View>
    );
  }

  renderTimeline = (value) => {
    if (!this.state.showTimeline) return null;
    return (
      <View style={{ maxWidth: WIDTH / 2, flexDirection: "row" }}>
        <TimelineNodes value={value} />
      </View>
    );
  };

  renderColorBg = (value, color, borderRadius) => {
    let { size, hideRing, backgroundColor, editing, backgroundOpacity } =
      this.props;
    let { noteValue } = this.state;

    let {
      onPress,
      onLongPress,
      onLongPressAdditionally,
      onDeselect,
      showQuickActions,
    } = this.props;
    let { showQuickEdit, refreshKey, isProject, isInfinite } = this.state;

    let gutterSize = (size / 2) * 0.2 * screenRatio;
    if (hideRing) gutterSize = 0;
    // let darkenBy = this.context.colors.darkenBy;
    let darkenBy = 1;
    let darkenedColor = colorHelpers.modifyHex(color, darkenBy);
    if (!value.id && !color) {
      darkenedColor = "transparent";
    }
    if (typeof value.id == "string" && value.id.includes("ftue")) {
      darkenedColor = "transparent";
    }
    if (noteValue) {
      darkenedColor = this.context.colors.fill;
      // borderRadius = this.context.sizes.borderRadius;
      borderRadius = this.context.sizes.smallBorderRadius;
    }
    if (!!value.backgroundColor) darkenedColor = value.backgroundColor;
    if (!!backgroundColor) darkenedColor = backgroundColor;
    return (
      <View
        style={[
          {
            ...StyleSheet.absoluteFillObject,
            top: gutterSize,
            right: gutterSize,
            bottom: gutterSize,
            left: gutterSize,
            borderRadius,
            opacity: value.backgroundOpacity || 1,
            // backgroundColor: ENV.DARK ? this.context.colors.darkest : this.context.colors.placeholder,
            zIndex: 1,
          },
          this.props.backgroundStyle,
        ]}
      >
        <TouchableOpacity
          onPressIn={() => {
            console.log("on  pres in");
            this.innerTouch = true;
          }}
          onPressOut={() => {
            setTimeout(() => {
              this.innerTouch = false;
            }, 0);
          }}
          style={{
            ...StyleSheet.absoluteFillObject,
            borderRadius: `50%`,
            zIndex: 1,
          }}
          onPress={(e) => {
            this.ref &&
              this.ref.measure((x, y, width, height, pageX, pageY) => {
                console.log(
                  `${value.text}: w:${width}, h:${height}, px:${pageX}, py:${pageY}`,
                );
              });

            if (editing) {
              this.inputRef && this.inputRef.focus();
            } else if (this.state.showTimeline) {
              this.setState({ showTimeline: false });
            } else if (showQuickActions || this.state.showQuickActions) {
              !!onDeselect && onDeselect();
              !!onHideQuickActions && onHideQuickActions();
              this.setState({ showQuickActions: false });
            } else if (!!this.props.onPress) {
              this.props.onPress(value);
            } else if (!!this.props.quickActionsOnPress) {
              this.setState({ showQuickActions: !this.state.showQuickActions });
            } else {
              RootNavigation.push("Value", { value, id: value.id }, e);
            }
          }}
          onLongPress={() => {
            if (onLongPress) {
              onLongPress(value);
              // } else if(onShowQuickActions){
              //   onShowQuickActions()
            } else {
              this.setState({
                showQuickActions: !this.state.showQuickActions,
                // showQuickEdit: true,
                refreshKey: refreshKey + 1,
              });
            }
            // if(onLongPressAdditionally){
            //   onLongPressAdditionally(value)
            // }
          }}
        >
          {textHelpers.doneSinceMilestone(value).length >= 7 &&
            !value.completed_at && (
              <View
                style={{
                  ...StyleSheet.absoluteFillObject,
                  // top: -gutterSize/2,
                  // right: -gutterSize/2,
                  // bottom: -gutterSize/2,
                  // left: -gutterSize/2,

                  borderRadius,
                  // shadowColor: colorHelpers.modifyHex(color, 1.2),
                  // shadowOpacity: 1,
                  // shadowRadius: (size/3)*screenRatio,
                  // elevation: 3,
                  // // transform: [{scale: 1.1}],
                }}
              />
            )}
          <View
            style={[
              {
                ...StyleSheet.absoluteFillObject,
                borderRadius,
                backgroundColor: darkenedColor,
                opacity: backgroundOpacity || 1,
                // backgroundColor: colorHelpers.modifyHex(color, 1.0),
                // opacity: ENV.DARK ? 0.4 : 0.5,
              },
              // textHelpers.doneSinceMilestone(value).length >= 7 && !value.completed_at ? {
              //   shadowColor: colorHelpers.modifyHex(color, 1.5),
              //   shadowOpacity: ENV.DARK ? 0.8 : 0.9,
              //   shadowRadius: (size/2)*screenRatio,
              //   // shadowOffset: {width: 1, height: 1},
              //   elevation: 3,
              //   transform: [{scale: 1.5}],
              // } : null,
            ]}
          />
        </TouchableOpacity>
      </View>
    );
  };

  renderIcon = (value, valColor, borderRadius) => {
    let { size, hideRing, backgroundOpacity } = this.props;
    let { noteValue } = this.state;
    let icon = valueHelpers.getIcon(value);
    if (!!icon) {
      let { color, opacity } = valueHelpers.iconColor(
        value,
        valColor,
        this.context.colorScheme,
      );
      let gutterSize = (size / 2) * 0.2 * screenRatio;
      if (hideRing) gutterSize = 0;
      if (noteValue) {
        color = this.context.colors.trim;
        opacity = ENV.DARK ? 0.15 : 0.3;
      }

      return (
        <View
          pointerEvents="none"
          style={{
            ...StyleSheet.absoluteFillObject,
            top: gutterSize,
            // top: '50%',
            right: gutterSize,
            bottom: gutterSize,
            // bottom: '-50%',
            left: gutterSize,
            // borderRadius,
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            zIndex: 1,
            opacity: backgroundOpacity || 1,
            // transform: [
            //   {translateY: '-50%'},
            // ],
          }}
        >
          <Icon
            name={icon}
            color={color}
            size={size * 0.7 * screenRatio}
            iconScale={0.9}
            style={{ opacity }}
            hideOverflow
          />
        </View>
      );
    }
  };

  renderText = (value, color, textIcon) => {
    let { size, noText, editing, editingText } = this.props;
    let { noteValue } = this.state;
    let showIcon = false;
    if (noText) return null;
    let textColor = noteValue ? color : valueHelpers.fontColor(value, color);
    let itemText = value.title || value.text;
    // let textColor = noteValue ? colorthis.context.colors.foreground : valueHelpers.fontColor(value, color);
    return (
      <View
        style={[
          this.styles().textWrapper,
          noteValue && this.styles().noteTextWrapper,
        ]}
        pointerEvents="none"
      >
        {!!textIcon ? (
          this.renderTextIcon(textIcon)
        ) : editing ? (
          <TextInput
            multiline
            autoHeight
            style={[
              // styleSheet.input,
              this.styles().text,
              // this.scaleFont(itemText),
              { width: "100%" },
              { color: textColor },
              noteValue ? this.styles().noteText : { fontWeight: "bold" },
            ]}
            placeholderTextColor={this.context.colors.lightForeground}
            autoFocus
            value={editingText}
            onChangeText={this.props.onChangeText}
            placeholder={this.props.placeholder}
            inputRef={(c) => (this.inputRef = c)}
          />
        ) : noteValue && false ? (
          <RichText color={textColor}>{itemText}</RichText>
        ) : (
          <Text
            style={[
              this.styles().text,
              this.scaleFont(itemText),
              { color: textColor },
              noteValue && this.styles().noteText,
              // !!maxWidth ? { maxWidth: maxWidth - (30)} : null
            ]}
            numberOfLines={noteValue ? undefined : 3}
            bold={!noteValue}
          >
            {valueHelpers.filterRichText(itemText, value)}
            {showIcon && itemText.length != 1 && this.state.isProject && (
              <MaterialCommunityIcons
                name="file-tree"
                color={this.context.colors.placeholder}
                style={[
                  { marginLeft: 10 * (size / 150) },
                  this.styles().text,
                  this.scaleFont(itemText),
                  { color: valueHelpers.fontColor(value, color) },
                ]}
              />
            )}
            {showIcon &&
              itemText.length != 1 &&
              itemText != "..." &&
              valueHelpers.isTracker(value) &&
              (valueHelpers.isInfiniteTracker(value) ? (
                <Entypo
                  name="back-in-time"
                  color={this.context.colors.placeholder}
                  style={[
                    { marginLeft: 10 * (size / 150) },
                    this.styles().text,
                    this.scaleFont(itemText),
                    { color: valueHelpers.fontColor(value, color) },
                  ]}
                />
              ) : (
                <Entypo
                  name="progress-two"
                  color={this.context.colors.placeholder}
                  style={[
                    { marginLeft: 10 * (size / 150) },
                    this.styles().text,
                    this.scaleFont(itemText),
                    { color: valueHelpers.fontColor(value, color) },
                  ]}
                />
              ))}
          </Text>
        )}
        {!!value.completed_at && !!value.achievement?.length && (
          <Text
            style={[
              this.styles().text,
              this.scaleFont(itemText),
              this.styles().achievement,
              { color, borderColor: color },
            ]}
            // numberOfLines={1}
            bold
            italic
          >
            {value.achievement}
          </Text>
        )}
      </View>
    );
  };

  scaleFont = (text = "") => {
    let { size, textIcon } = this.props;
    let fontSize = this.context.sizes.default;

    fontSize -= 3;
    if (text.length > 10) {
      fontSize -= (text.length - 10) * 0.3;
      fontSize = Math.max(this.context.sizes.base, fontSize);
    }
    if (
      !this.props.pill &&
      (text.length < 3 ||
        text == "..." ||
        typeof text == "object" ||
        !!textIcon)
    ) {
      // fontSize = this.context.sizes.default * 2.5;
      fontSize = this.context.sizes.default * 1.5;
    }
    fontSize = fontSize * (size / 100);
    // fontSize = Math.max(this.context.sizes.base, fontSize)
    // console.log('fontsize:', fontSize)
    let lineHeight = fontSize * 1.2;
    return { fontSize, lineHeight };
  };

  renderTextIcon = (icon) => {
    let { value } = this.props;
    let color = valueHelpers.getColor(value);
    let itemText = value.title || value.text;
    let style = {
      fontSize: this.scaleFont(itemText).fontSize,
      color: valueHelpers.fontColor(value, color),
    };
    if (icon == "cancel")
      return <MaterialCommunityIcons name="cancel" style={style} />;
    else if (icon == "add") return <Entypo name="plus" style={style} />;
    return null;
  };

  renderRing = (value, color) => {
    // return null
    let {
      ringColor,
      emptyColor,
      size,
      selected,
      hideRing,
      coloredNotches,
      date,
      progressBar,
      momentRing,
    } = this.props;
    // let familyColor = valueHelpers.getColor(value, 'familyColors')
    // let ringColor = colorHelpers.averageColor([color, familyColor])
    ringColor = color;
    if (hideRing && !progressBar) return null;
    if (value.is_note) return null;
    if (!!value.child_ids?.length && this.context.pensieve) return null;
    return (
      <View style={{ ...StyleSheet.absoluteFillObject }}>
        {momentRing && false ? (
          <MomentRing
            notches={valueHelpers.getNotchArray(value)}
            color={this.props.ringColor || ringColor}
            size={size + this.context.sizes.large}
            strokeFactor={0.4}
            gutter={this.context.sizes.small}
            // gapless
          />
        ) : (
          <ProgressRing
            value={value}
            color={this.props.ringColor || ringColor}
            emptyColor={this.props.emptyColor}
            size={size}
            selected={selected}
            coloredNotches={this.props.coloredNotches}
            // coloredNotches={false}
            noteValue={this.state.noteValue}
            date={this.props.date}
            // progressBar={progressBar || this.state.isInfinite}
            progressBar={progressBar}
            // simplified={momentRing}
          />
        )}
      </View>
    );
  };

  renderQuickActions = (value) => {
    let { size, relationship } = this.props;
    let { showQuickActions } = this.state;
    if (showQuickActions) {
      return (
        <QuickActions
          value={value}
          relationship={relationship}
          onClose={() => {
            this.setState({ showQuickActions: false });
          }}
          onQuickEdit={() => {
            this.setState({ showQuickEdit: true });
          }}
          scale={size / 150}
          showTimeline={this.props.quickActionTimeline}
          toggleTimeline={() =>
            this.setState({
              showTimeline: this.state.showTimeline ? false : true,
            })
          }
        />
      );
    }
  };

  renderQuickEdit = (value) => {
    return (
      <ValueInspector
        value={value}
        // onProgress={this.props.onProgress}
        // onCreateChild={this.props.onCreateChild}
        onClose={() =>
          this.setState({ showQuickActions: false, showQuickEdit: false })
        }
      />
    );
  };

  styles = () => ({
    wrapper: {
      overflow: "visible",
      borderRadius: 999,
    },
    noteWrapper: {},
    circleItem: {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderColor: "#444",
    },
    textWrapper: {
      padding: this.context.sizes.base,
      zIndex: 1,
    },
    noteTextWrapper: {
      alignSelf: "flex-start",
    },
    text: {
      color: this.context.colors.foreground,
      textAlign: "center",
    },
    noteText: {
      textAlign: "left",
      fontSize: this.context.sizes.default,
      lineHeight: this.context.sizes.default * 1.2,
    },
    achievement: {
      backgroundColor: this.context.colors.empty,
      borderWidth: 2,
      color: this.context.colors.empty,
      borderRadius: 50,
      padding: this.context.sizes.small,
      position: "absolute",
      bottom: "100%",
      // width: "auto",
      // flex: 1,
      // textOverflow: ''
      // overflow: 'visible',
      // flex: 1,
    },
  });
}
